module.exports = __webpack_public_path__ + "static/media/WISHC.ad4fbddc.png";